import { SET_WORKOUT_TEMPLATES, SET_WORKOUT_TEMPLATE_BY_ID, RESET_WORKOUT_TEMPLATE_BY_ID } from './workoutTemplateTypes';

export const setWorkoutTemplates = (data) => ({
	type: SET_WORKOUT_TEMPLATES,
	payload: data,
});

export const setWorkoutTemplateById = (data) => ({
	type: SET_WORKOUT_TEMPLATE_BY_ID,
	payload: data,
});

export const resetWorkoutTemplateById = () => ({
	type: RESET_WORKOUT_TEMPLATE_BY_ID,
});
